<template>
  <div>
    <!-- 订单调整弹窗 -->
    <!-- 订单调整 -->
    <el-dialog :title="$t('message.orderAdjust')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="500px" center>
      <!-- 下单类型 -->
      <el-tabs v-model="orderType" type="card">
        <!-- 人员调整 -->
        <el-tab-pane :label="$t('message.personAdjustment')" name="1"></el-tab-pane>
        <!-- 订单类型编辑 -->
        <el-tab-pane :label="$t('message.orderTypeEdit')" name="2"></el-tab-pane>

      </el-tabs>
      <!-- 人员调整内容 -->
      <div class="content" v-if="orderType == '1'">
        <div class="label">订单人员变更：</div>
        <div class="value">
          <div class="allot">
            <el-select v-model="allotVal.y_id" filterable :placeholder="$t('message.salesman')">
              <el-option v-for="item in y" :key="item.id" :label="item.realname" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="allot">
            <el-select v-model="allotVal.p_id" filterable :placeholder="$t('message.distributionMember')">
              <el-option v-for="item in p" :key="item.id" :label="item.realname" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="allot">
            <el-select v-model="allotVal.g_id" filterable :placeholder="$t('message.buyer')">
              <el-option v-for="item in g" :key="item.id" :label="item.realname" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>

      </div>
      <!-- 订单类型编辑内容 -->
      <div class="content" v-if="orderType == '2'">
        <el-radio-group v-model="typeData.type">
          <el-radio :label="item.key" v-for="(item, index) in typeList" :key="index">{{ item.value }}</el-radio>
        </el-radio-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">
          {{ $t("message.cancel") }}
        </el-button>
        <!-- 人员调整保存 -->
        <el-button type="primary" @click="adjustOrderAdmin" v-if="orderType == '1' && isAuth(172)">
          {{ $t("message.save") }}
        </el-button>
        <!-- 订单类型编辑保存 -->
        <el-button type="primary" @click="updateType" v-if="orderType == '2' && isAuth(181)">
          {{ $t("message.save") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>

export default {

  data() {
    return {
      orderType: "1",
      allotVal: {},//调整
      dialogVisible: false,
      typeData: {
        order_sn: [],
        type: "",
      },
    };
  },
  computed: {
    g() {
      return this.$store.state.authWorkGroupAdmin.g;
    },
    y() {
      return this.$store.state.authWorkGroupAdmin.y;
    },
    p() {
      return this.$store.state.authWorkGroupAdmin.p;
    },
    typeList() {
      return this.$store.state.typeList;
    },
  },
  methods: {

    // 分配
    adjustOrderAdmin() {
      this.$api.orderApi.adjustOrderAdmin(this.allotVal).then((res) => {
        this.dialogVisible = false;

        this.$parent.refresh(1);
      });
    },
    // 订单类型编辑
    updateType() {
      this.$api.orderApi.updateType(this.typeData).then((res) => {
        this.dialogVisible = false;

        this.$parent.refresh(1);
      });
    },

  },
};
</script>
<style lang='scss' scoped>
.content {
  padding: 20px 20px 0;
  display: flex;

  .value {
    flex: 1;
  }

  .allot {
    margin: 0px 20px 20px;

    .el-select {
      width: 100%;
    }

  }

  /deep/.el-radio {
    margin-bottom: 20px;
  }
}
</style>